<template>
  <b-card>
    <b-row class="mt-2">
      <div class="mb-2">
        <b-button class="float-left" variant="primarySpore" @click="back()">Regresar</b-button>
      </div>
    </b-row>
    <div>
      <b-row class="mt-2">

        <div class="col-12">
          <b-row>
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <h3>Listado Miembros para Cuadrilla</h3>
            </b-col>
          </b-row>
        </div>

        <b-col class="mt-2" cols="12" md="12">
          <b-table ref="refUserListTable" class="position-relative" :items="this.responseTable" :fields="this.tableColumns" primary-key="id" show-empty empty-text="No hay registros">
            <template #head(invoiceStatus)>
              <feather-icon icon="TrendingUpIcon" class="mx-auto"/>
            </template>

            <template #cell(email)="data">
              <div class="text-left">
                <span class="text-nowrap">
                  {{ data.item.email }}
                </span>
              </div>
            </template>

            <template #cell(firstName)="data">
                <div class="text-center">
                  {{ data.item.firstName }}
                </div>
            </template>

            <template #cell(lastName)="data">
                <div class="text-center">
                  {{ data.item.lastName }}
                </div>
            </template>

            <template #cell(type)="data">
              <b-row>
                <b-col cols="12" md="12" class="custom-search d-flex justify-content-center">
                  <div class="text-center">
                    <listItem :value="(data.item.type === 'A' ? 'Administrador' : data.item.type === 'C' ? 'Administrador CFE' : data.item.type === 'S' ? 'Supervisor' : data.item.type === 'I' ? 'Instalador' : '')" description="Tipo" img="alias"/>
                  </div>
                </b-col>
              </b-row>
            </template>

            <template #cell(teamUuid)="data">
                <div class="text-center">
                <b-avatar size="32" :variant="data.item.teamUuid ? 'light-success' : 'light-warning' ">
                  <feather-icon :icon="data.item.teamUuid ? 'CheckCircleIcon': 'AlertCircleIcon'"/>
                </b-avatar>&nbsp;
                <div :class="data.item.teamUuid ? 'text-success align-text-top d-inline-block' : 'text-warning align-text-top d-inline-block'">
                  <b>{{ data.item.teamUuid ? 'En Cuadrilla' : 'Sin Cuadrilla' }}</b>
                </div>
              </div>
            </template>

            <!-- Column: Actions -->
            <template #cell(actions)="data" >
              <b-row>
                <b-col cols="12" md="12" class="custom-search d-flex justify-content-center">
                  <div class="d-flex align-items-center">
                    <b-button variant="primarySpore" class="btn-icon p-1 ml-1" @click="assingTeam(data.item.uuid)" title="Asignar" v-b-tooltip.hover="{ placement: 'top' }">
                      <feather-icon icon="UserPlusIcon" :width="18" :height="18"/>
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </template>
          </b-table>
        </b-col>
        <br><br>
      </b-row>
    </div>

  </b-card>
</template>

<script>
// import { empty } from '@/libs/tools/helpers'
import listItem from '@core/spore-components/listItem/listItem.vue'
import {
  BButton, BRow, BCol, BCard, VBTooltip, BTable, BAvatar
} from 'bootstrap-vue'
import request from '@/libs/request/index'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BTable,
    BAvatar,
    listItem
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data () {
    return {
      uuid: this.$route.params.uuid,
      response: [],
      tableColumns: [
        { thClass: 'text-left', key: 'email', sortable: true, label: 'Correo Electrónico' },
        { thClass: 'text-center', key: 'firstName', sortable: true, label: 'Nombre(s)' },
        { thClass: 'text-center', key: 'lastName', sortable: true, label: 'Apellido(s)' },
        { thClass: 'text-center', key: 'type', sortable: true, label: 'Tipo' },
        { thClass: 'text-center', key: 'teamUuid', sortable: true, label: 'En Cuadrilla' },
        { thClass: 'text-center', key: 'actions', label: 'Acciones' }
      ],
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      responseTable: []
    }
  },
  methods: {
    async assingTeam (installer) {
      const params = {
        url: `users/assignTeam/${installer}`,
        method: 'PUT',
        params: {
          teamUuid: this.uuid
        }
      }
      await request(params).then(data => {
        this.getTeamsMembers()
      })
    },
    async getTeamsMembers () {
      const params = {
        url: 'users/installers/list',
        method: 'GET',
        params: { divisionUuid: this.$store.state.session.AppActiveUser().division.uuid }
      }
      await request(params).then(data => {
        this.responseTable = []
        if (data.data.code === 200) {
          for (let x = 0; x < data.data.data.length; x++) {
            if (data.data.data[x].teamUuid !== this.uuid) {
              this.responseTable.push({
                uuid: data.data.data[x].uuid,
                email: data.data.data[x].email,
                firstName: data.data.data[x].firstName,
                lastName: data.data.data[x].lastName,
                type: data.data.data[x].type,
                teamUuid: data.data.data[x].teamUuid
              })
            }
          }
        }
      })
    },
    back () {
      this.$router.push(`/teams/${this.uuid}/members`)
    }
  },
  created () {
    this.getTeamsMembers()
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
